import React from 'react';

import { ENVIRONMENT } from '@/constants';

interface Props {
  readonly when?: boolean;
}

export const DisableInProduction: React.FC<React.PropsWithChildren<Props>> = (
  props: React.PropsWithChildren<Props>,
): React.ReactNode => {
  const { when = true } = props;

  const { children } = props;
  if (ENVIRONMENT === 'develop' || !when) {
    return children;
  } else {
    return <></>;
  }
};
